/** Raw response of `GET /clinics/{clinicSn}/overview` — headline per-year metrics. */
export interface AysClinicOverviewResponse {
  aerzte?: number;
  pflegekraefte?: number;
  betten?: number;
  vollstationaereFaelle?: number;
  teilstationaereFaelle?: number;
  ambulanteFaelle?: number;
  /**
   * Fallzahl der stationsäquivalenten psychiatrischen Behandlung (StäB). The
   * backend sends an explicit `0` for clinics that report none — only a genuinely
   * missing metric is null — so the KPI tile shows "0" there, never an em-dash
   * (BDA-5793). The `/case-numbers` section calls the same figure
   * `staebFallzahl`; the two names are the backend's, not a typo.
   */
  staebFaelle?: number;
}

export class AysClinicOverview {
  public static fromObj(obj: AysClinicOverviewResponse): AysClinicOverview {
    return new AysClinicOverview(
      obj.aerzte,
      obj.pflegekraefte,
      obj.betten,
      obj.vollstationaereFaelle,
      obj.teilstationaereFaelle,
      obj.ambulanteFaelle,
      obj.staebFaelle,
    );
  }

  constructor(
    public aerzte?: number,
    public pflegekraefte?: number,
    public betten?: number,
    public vollstationaereFaelle?: number,
    public teilstationaereFaelle?: number,
    public ambulanteFaelle?: number,
    public staebFaelle?: number,
  ) {}
}
